import { MicrophoneIcon } from "@heroicons/react/solid";
import React from "react";
import { conferences } from "../data";

export default function Upcoming_Research() {
    return (
        <section id="upcoming_research" className="text-gray-400 bg-gray-900 body-font">
          <div className="container px-5 py-10 mx-auto text-center lg:px-40">
            <div className="flex flex-col w-full mb-20">
              <MicrophoneIcon className="mx-auto inline-block w-10 mb-4" />
              <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
                Conferences I've spoken at
              </h1>
              <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                These are some of the talks and demos I've given.
              </p>
            </div>
            <div className="flex flex-wrap -m-4">
              {conferences.map((conferences) => (
                <a
                    href={conferences.link}
                    key={conferences.image}
                    className="sm:w-1/2 w-100 p-4"
                  >
                    <div className="flex relative group">
                      <img
                        alt="gallery"
                        className="absolute inset-0 w-full h-full object-cover object-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                        src={conferences.image}
                      />

                      <div className="px-8 py-10 relative z-10 w-full border-4 border-gray-800 bg-gray-900 opacity-100 group-hover:opacity-0 transition-opacity duration-300">
                        <h2 className="tracking-widest text-sm title-font font-medium text-green-400 mb-1">
                          {conferences.subtitle}
                        </h2>
                        <h1 className="title-font text-lg font-medium text-white mb-3">
                          {conferences.title}
                        </h1>
                        <p className="leading-relaxed">{conferences.description}</p>
                      </div>
                    </div>
                  </a>
                  /*
                <a
                  href={upcoming_research.link}
                  key={upcoming_research.image}
                  className="sm:w-1/2 w-100 p-4">
                  <div className="flex relative">
                    <img
                      alt="gallery"
                      className="absolute inset-0 w-full h-full object-cover object-center"
                      src={upcoming_research.image}
                    />
                    <div className="px-8 py-10 relative z-10 w-full border-4 border-gray-800 bg-gray-900 opacity-0 hover:opacity-100">
                      <h2 className="tracking-widest text-sm title-font font-medium text-green-400 mb-1">
                        {upcoming_research.subtitle}
                      </h2>
                      <h1 className="title-font text-lg font-medium text-white mb-3">
                        {upcoming_research.title}
                      </h1>
                      <p className="leading-relaxed">{upcoming_research.description}</p>
                    </div>
                  </div>
                </a>
                */
              ))}
            </div>
          </div>
        </section>
    );
}



// WEBPACK FOOTER //
// ./src/components/Conferences.js